import { render } from "./SystemAdmin3.vue?vue&type=template&id=f33ae09c"
import script from "./SystemAdmin3.vue?vue&type=script&lang=js"
export * from "./SystemAdmin3.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__